import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { push } from 'connected-react-router';
import { Row, Col } from 'react-bootstrap';
import FormViewGrid from 'components/atoms/form/FormViewGrid';
import ButtonStandardCompact from 'components/atoms/buttons/compact/Primary';
import ButtonIconSecondary from 'components/molecules/buttons/ButtonIconSecondary';
import { Link } from 'react-router-dom';
import { fetchCapabilityGroup, deleteCapabilityGroup } from 'services/capabilityGroups/duck';
import { withTheme } from 'styled-components';
import FormHeading from 'components/atoms/form/FormHeading';
import ProtectedComponent from 'hoc/ProtectedComponent';
import { CAPABILITY_GROUP_DELETE } from 'constants/capabilities';
import Pagination, { RowsPerPageDefault } from 'components/molecules/tables/components/Pagination';
import StyledReactTable from 'components/molecules/StyledReactTable';
import CellDiv from 'components/molecules/tables/components/CellDiv';
import FormSubHeading from 'components/atoms/form/FormSubHeading';

const DeleteIconButton = ProtectedComponent({
    requiredCapabilities: [CAPABILITY_GROUP_DELETE]
})(ButtonIconSecondary);

class CapabilityGroupViewContainer extends Component {
    componentDidMount() {
        const capabilityGroupId = this.props.match.params.id;

        if (this.props.fetchCapabilityGroup && capabilityGroupId) {
            this.props.fetchCapabilityGroup({ capabilityGroupId });
        }
    }

    render() {
        const { name = null, Capabilities = [], Users = [] } = this.props.capabilityGroup || {};
        return (
            <FormViewGrid fluid>
                <FormHeading>{name}</FormHeading>
                <Row style={{ marginTop: 15 }}>
                    <Col xs={6}>
                        <ButtonStandardCompact
                            type="submit"
                            onClick={() => this.props.push(`/admin/capability-groups/${this.props.match.params.id}/edit`)}>
                            Edit
                        </ButtonStandardCompact>
                    </Col>
                    <Col xs={6}>
                        <DeleteIconButton icon="trash" iconColor="#F00" onClick={() => this.props.deleteCapabilityGroup(this.props.capabilityGroup)} style={{ position: 'absolute', right: 0 }}>
                            Delete
                        </DeleteIconButton>
                    </Col>
                </Row>
                <Row>
                    <Col md={6}>
                        {/* <!-- Left column --> */}
                        <FormSubHeading>Capabilities</FormSubHeading>
                        <StyledReactTable
                            title='Capabilities'
                            data={Capabilities}
                            columns={[
                                {
                                    Header: 'ID',
                                    accessor: 'id',
                                    minWidth: 20,
                                    Cell: row => <CellDiv value={row.value} />,
                                },
                                {
                                    Header: 'NAME',
                                    accessor: 'name',
                                    type: 'string',
                                    Cell: row => <CellDiv value={row.value} />,
                                },
                                {
                                    Header: 'DESCRIPTION',
                                    accessor: 'description',
                                    type: 'string',
                                    Cell: row => <CellDiv value={row.value} />,
                                }
                            ]}
                            getTheadThProps={() => ({ style: { outline: 0, } })}
                            defaultSorted={[
                                {
                                    id: 'name'
                                }
                            ]}
                            showPagination={Capabilities.length > RowsPerPageDefault}
                            PaginationComponent={Pagination}
                            defaultPageSize={RowsPerPageDefault}
                            minRows={Capabilities.length < RowsPerPageDefault ?
                                Capabilities.length : RowsPerPageDefault}
                            className="-highlight"
                        />
                    </Col>
                    <Col md={6}>
                        {/* <!-- Right column --> */}
                        <FormSubHeading>Users</FormSubHeading>
                        <StyledReactTable
                            title='Users'
                            data={Users}
                            columns={[
                                {
                                    Header: 'ID',
                                    accessor: 'id',
                                    minWidth: 20,
                                    Cell: row => <Link to={`/admin/users/${row.value}/edit`}><CellDiv value={row.value} /></Link>,
                                },
                                {
                                    Header: 'NAME',
                                    id: 'name',
                                    accessor: row => `${row.firstName} ${row.lastName}`,
                                    type: 'string',
                                    Cell: row => <CellDiv value={row.value} />,
                                },
                                {
                                    Header: 'EMAIL',
                                    accessor: 'email',
                                    type: 'string',
                                    Cell: row => <CellDiv value={row.value} />,
                                }
                            ]}
                            getTheadThProps={() => ({ style: { outline: 0, } })}
                            defaultSorted={[
                                {
                                    id: 'name'
                                }
                            ]}
                            showPagination={Users.length > RowsPerPageDefault}
                            PaginationComponent={Pagination}
                            defaultPageSize={RowsPerPageDefault}
                            minRows={Users.length < RowsPerPageDefault ? Users.length : RowsPerPageDefault}
                            className="-highlight"
                        />
                    </Col>
                </Row>
            </FormViewGrid>
        );
    }
}


const mapStateToProps = state => ({
    capabilityGroup: state.capabilityGroups.capabilityGroup
});

export default compose(
    withTheme,
    connect(mapStateToProps, { fetchCapabilityGroup, deleteCapabilityGroup, push })
)(CapabilityGroupViewContainer);



// WEBPACK FOOTER //
// ./src/containers/CapabilityGroupViewContainer.js